'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _constants = require('../../constants');

var _common = require('../common');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ROUTING = _constants.AppConstants.ROUTING;
var getOrDefault = _utils.FormattingUtils.getOrDefault,
    formatPhoneNumber = _utils.FormattingUtils.formatPhoneNumber;

var RelationshipRow = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(RelationshipRow, _Component);

  function RelationshipRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RelationshipRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelationshipRow.__proto__ || Object.getPrototypeOf(RelationshipRow)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'showConfirmDelete', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RelationshipRow, [{
    key: 'handleDelete',
    value: function handleDelete() {
      var _props = this.props,
          onDelete = _props.onDelete,
          id = _props.relationship.id;

      onDelete(id);
      this.onToggleConfirmDelete();
    }
  }, {
    key: 'onToggleConfirmDelete',
    value: function onToggleConfirmDelete() {
      this.showConfirmDelete = !this.showConfirmDelete;
    }
  }, {
    key: 'renderConfirmDelete',
    value: function renderConfirmDelete() {
      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { className: 'col-confirm-delete', colSpan: 4 },
          _react2.default.createElement(_common.ConfirmDelete, {
            element: 'div',
            message: 'Delete this association?',
            showConfirmDelete: true,
            onClickDelete: this.handleDelete,
            onClickCancel: this.onToggleConfirmDelete
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.showConfirmDelete) {
        return this.renderConfirmDelete();
      }

      var _props2 = this.props,
          model = _props2.model,
          relationship = _props2.relationship,
          type = _props2.type,
          relatedContact = type !== 'organizations' ? relationship.first_party : relationship.second_party,
          name = relatedContact.name,
          human_readable_type = relatedContact.human_readable_type,
          phone_number = relatedContact.phone_number,
          detailPageURL = type !== 'organizations' ? ROUTING.organizations : ROUTING.peopleList,
          hasWarning = type === 'organizations' ? !!relationship.second_party.warning : !!relationship.first_party.warning;


      return _react2.default.createElement(
        'tr',
        null,
        !model.isMedical && _react2.default.createElement(
          'td',
          { className: 'col-warning' },
          hasWarning && _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' })
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-name' },
          _react2.default.createElement(
            _common.Link,
            { to: detailPageURL + '/' + relatedContact.id },
            getOrDefault(name)
          )
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-role' },
          (0, _startCase3.default)(human_readable_type)
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-phone' },
          formatPhoneNumber(phone_number)
        ),
        _react2.default.createElement(
          'td',
          { className: 'col-btn' },
          _react2.default.createElement(_common.DeleteButton, { className: 'pull-right', onClick: this.onToggleConfirmDelete })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return RelationshipRow;
}(_react.Component), _class3.propTypes = {
  model: _propTypes2.default.object.isRequired,
  onDelete: _propTypes2.default.func.isRequired,
  relationship: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.oneOf(['organizations', 'people']).isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showConfirmDelete', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class;

var _default = RelationshipRow;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/page-contacts/RelationshipRow.js');
  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-contacts/RelationshipRow.js');
  reactHotLoader.register(formatPhoneNumber, 'formatPhoneNumber', '/app/src/components/page-contacts/RelationshipRow.js');
  reactHotLoader.register(RelationshipRow, 'RelationshipRow', '/app/src/components/page-contacts/RelationshipRow.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-contacts/RelationshipRow.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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